import { Component } from '@angular/core';
import { IContext, primaryButton, label, table, iconButton, secondaryButton } from 'msteams-ui-styles-core'

import { MsTeamsContextProvider } from '../core/providers/msteamscontext.provider';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
})
export class AccessDeniedComponent {

  constructor(private _msTeamsContextProvider: MsTeamsContextProvider,
              private router: Router,
              private _route: ActivatedRoute) { }

  ngOnInit() {

    
  }
    

}
